<template>
  <div>
    <div class="p-5 w-full flex flex-col">
      <div class="flex flex-row">
        <div class="w-1/3 flex flex-row items-center">
          <p class="font-semibold text-3xl">
            List Fleet Arrangement
          </p>
        </div>
        <div class="w-2/3 flex flex-row items-center justify-end">
          <date-picker
            v-model="dateStart"
            type="date"
            value-type="format"
            format="DD-MMM-YYYY"
            placeholder="Start date"
          />
          <span class="mx-3"> - </span>
          <date-picker
            v-model="dateEnd"
            type="date"
            value-type="format"
            format="DD-MMM-YYYY"
            placeholder="Start date"
          />
          <vs-button
            ref="fetchButton"
            icon="visibility"
            color="primary"
            type="filled"
            class="mx-3 rounded-xl vs-con-loading__container"
            @click="isFetch = true"
          />
          <div class="mx-3 divider" />
          <vs-button
            ref="downloadButton"
            color="secondary"
            type="filled"
            class="mx-3 w-32 font-semibold vs-con-loading__container"
            @click="isDownload = true"
          >
            Export Excel
          </vs-button>
        </div>
      </div>
      <div class="mt-5 p-2 flex flex-row rounded-lg bg-white">
        <p
          v-for="(item, index) of tabs"
          class="w-1/4 p-3 cursor-pointer text-center"
          :key="index"
          :class="{'shadow font-semibold rounded-lg bg-primary text-white': tabActive === item.id}"
          @click="onTabChange(item)"
        >
          {{ item.name }}
        </p>
      </div>
      <div class="mt-5">
        <cycle-time
          v-if="tabActive === 1"
          :is-fetch.sync="isFetch"
          :is-download.sync="isDownload"
          :date-range="[dateStart, dateEnd]"
        />
        <barge-capacity
          v-else-if="tabActive === 2"
          :is-fetch.sync="isFetch"
          :is-download.sync="isDownload"
          :date-range="[dateStart, dateEnd]"
        />
        <tonnage
          v-else-if="tabActive === 3"
          :is-fetch.sync="isFetch"
          :is-download.sync="isDownload"
          :date-range="[dateStart, dateEnd]"
        />
        <requirement
          v-else
          :is-fetch.sync="isFetch"
          :is-download.sync="isDownload"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from '@/components/datePicker'
import { PAGE_TITLE } from '@/fixtures/Constants'
import BargeCapacity from '@/views/fleetArrangement/bargeCapacity'
import CycleTime from '@/views/fleetArrangement/cycleTime'
import Requirement from '@/views/fleetArrangement/requirement'
import Tonnage from '@/views/fleetArrangement/tonnage'

export default {
  components: {
    CycleTime,
    BargeCapacity,
    Tonnage,
    Requirement,
    DatePicker
  },
  metaInfo() {
    return {
      title: `${PAGE_TITLE} ${this.tabs.find(item => item.id === this.tabActive).name}`
    }
  },
  data() {
    return {
      isFetch: false,
      isDownload: false,
      tabActive: 1,
      tabs: [
        {
          id: 1,
          name: 'Cycle Time'
        },
        {
          id: 2,
          name: 'Barge Capacity'
        },
        {
          id: 3,
          name: 'Tonnage Plan SOS & Sales Plan'
        },
        {
          id: 4,
          name: 'Fleet Requirement'
        }
      ],
      dateStart: null,
      dateEnd: null
    }
  },
  watch: {
    isFetch: {
      handler(val) {
        if (this.dateStart && this.dateEnd) {
          this.changeButtonState(val, this.$refs.fetchButton.$el)
        }
      }
    },
    isDownload: {
      handler(val) {
        if (this.dateStart && this.dateEnd) {
          this.changeButtonState(val, this.$refs.downloadButton.$el)
        }
      }
    }
  },
  methods: {
    onTabChange(item) {
      this.tabActive = item.id
      this.$nextTick(() => {
        this.isFetch = true
      })
    },
    changeButtonState(state, container) {
      if (state) {
        this.$vs.loading({
          background: 'secondary',
          color: '#FFF',
          container,
          scale: 0.35
        })
        return
      }

      this.$vs.loading.close(container)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/.datepicker {
  width: 145px !important;
}

/deep/.mx-input-wrapper {
  background-color: white !important;
}

.divider {
  @apply h-10;

  border-left: solid 1px #DEDEDE;
}
</style>
